import request from '@/apis/request'
const resource = 'game-types' 

export default {
  get: (params = {}) => {
    return request.get(`${resource}`, { params })
  }, 
}